import { render, staticRenderFns } from "./chatForm.vue?vue&type=template&id=33d4be82&scoped=true&"
import script from "./chatForm.vue?vue&type=script&lang=ts&"
export * from "./chatForm.vue?vue&type=script&lang=ts&"
import style0 from "./chatForm.vue?vue&type=style&index=0&id=33d4be82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d4be82",
  null
  
)

export default component.exports